module.exports = __webpack_public_path__ + "static/media/Motivo1.a6863581.png";